module.exports = __webpack_public_path__ + "static/media/0110_IMG_LA_BERGERIE_AVEC.b67f095d.webp";